import { ReactElement, ReactNode } from 'react';

import { Paper, Typography, Box, Stack, tokens } from '@cast/design-system';

type ChartConfig = {
  title?: string;
  chart: ReactElement;
  noPaper?: boolean;
};

type ChartContainerProps = {
  compact?: boolean;
  title?: string;
  titleAdornment?: ReactNode;
  charts: ChartConfig[];
  dateRange?: ReactElement;
  selector?: ReactElement;
  testId?: string;
  reverseActions?: boolean;
  noPaper?: boolean;
};

export const ChartsContainer = ({
  compact = false,
  title,
  titleAdornment,
  charts,
  dateRange,
  selector,
  testId = 'chart-container',
  reverseActions = false,
  noPaper = false,
}: ChartContainerProps) => {
  return (
    <Stack gap={compact ? 16 : 8} data-testid={testId}>
      <Stack direction="row" justifyContent="space-between">
        {!compact && title && (
          <Stack direction="row" alignItems="center" gap={8}>
            <Typography variant="h6" data-testid="title">
              {title}
            </Typography>
            {titleAdornment}
          </Stack>
        )}

        <Stack
          direction={reverseActions ? 'row-reverse' : 'row'}
          data-testid="actions"
          gap={8}
          flex={compact ? 1 : undefined}
        >
          {selector && <Box flex={1}>{selector}</Box>}
          {dateRange}
        </Stack>
      </Stack>
      <Stack gap={24}>
        {charts.map(({ title, chart, noPaper: _noPaper }, index) => (
          <Stack gap={8} key={index}>
            {!compact && title && (
              <Typography
                variant="A1"
                color={tokens.theme.fg.structural.secondary}
              >
                {title}
              </Typography>
            )}
            {compact || noPaper || _noPaper ? (
              <Stack data-testid="chart">{chart}</Stack>
            ) : (
              <Paper data-testid="chart">{chart}</Paper>
            )}
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
